import { PromoModel } from '@pukka/api';

const promoListScheduledData: PromoModel.Response[] = [
  {
    id: 109606,
    name: 'Promo Wow',
    business_id: 19847,
    outlet_ids: [30624, 30793, 610355],
    promo_type_id: 4,
    multiple: false,
    active: true,
    start_date: '2025-03-31T17:00:00Z',
    end_date: '2025-04-15T16:59:59.999Z',
    start_time: 0,
    end_time: 1439,
    days: [true, true, true, true, true, true, true],
  },
];

const promoListOngoingData: PromoModel.Response[] = [
  {
    id: 109607,
    name: 'Promo A',
    business_id: 19847,
    outlet_ids: [30624],
    promo_type_id: 2,
    multiple: true,
    active: true,
    start_date: '2023-02-22T10:16:43.188Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 109599,
    name: 'Promo AB',
    business_id: 19847,
    outlet_ids: [30624],
    promo_type_id: 2,
    multiple: true,
    active: true,
    start_date: '2023-02-22T10:00:13.373Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 72516,
    name: 'sfsdf',
    business_id: 19847,
    outlet_ids: [30793],
    promo_type_id: 2,
    multiple: true,
    active: true,
    start_date: '2022-07-18T04:40:31.804Z',
    days: [true, true, true, true, true, true, true],
  },
];

const promoListInactiveData: PromoModel.Response[] = [
  {
    id: 109605,
    name: 'Promo Free item',
    business_id: 19847,
    outlet_ids: [610354],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2023-02-22T10:11:43.933Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 109604,
    name: 'Promo 1',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2023-02-22T10:10:57.985Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 109603,
    name: 'Promo 2',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2023-02-22T10:09:10.337Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 109602,
    name: 'Promo 3',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2023-02-22T10:08:27.795Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320474,
    name: 'Promo 4',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320475,
    name: 'Promo 5',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320476,
    name: 'Promo 6',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320477,
    name: 'Promo 7',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320478,
    name: 'Promo 8',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320479,
    name: 'Promo 9',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320480,
    name: 'Promo 10',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320481,
    name: 'Promo 11',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320482,
    name: 'Promo 12',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320483,
    name: 'Promo 13',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320484,
    name: 'Promo 14',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320485,
    name: 'Promo 15',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320486,
    name: 'Promo 16',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320487,
    name: 'Promo 17',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 232088,
    name: 'Promo 18',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320489,
    name: 'Promo 19',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320490,
    name: 'Promo 20',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320491,
    name: 'Promo 21',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
  {
    id: 2320492,
    name: 'Promo 22',
    business_id: 19847,
    outlet_ids: [610355],
    promo_type_id: 2,
    multiple: true,
    active: false,
    start_date: '2022-01-10T02:43:32.349Z',
    days: [true, true, true, true, true, true, true],
  },
];

const promoListByStatusData: Record<PromoModel.Status, PromoModel.Response[]> = {
  inactive: promoListInactiveData,
  scheduled: promoListScheduledData,
  ongoing: promoListOngoingData,
};

const promoListsData: PromoModel.Response[][] = [
  [
    ...promoListOngoingData, // 3
    ...promoListScheduledData, // 1
    ...promoListInactiveData.slice(0, 21), // 21
  ],
  [
    ...promoListInactiveData.slice(-2), // 2
  ],
];

export { promoListByStatusData, promoListsData };
